import { observer } from "mobx-react-lite";
import './SampleCard.scss'
import { Badge } from "./Badge";
import BadgeIcon from "./BadgeIcon";
import PetTooltip from "./PetTooltip";
import { useRef, useState } from "react";
import { publicUrl } from "../utils/url";
import ExpandIcon from "../icons/ExpandIcon";
import Img from "./Img";
import Loader from "./Loader";
import { delay } from "../utils/Events";
import { _t } from '../utils/Lang';


const SampleCard = observer(({ name, checked = false, className = '',
    imageUrl = '',
    onExpandClick,
    onClick, }) => {

    const expandRef = useRef();
    const [pendingUpdate, setPendingUpdate] = useState(false);
    const inCart = checked;

    var classes = ['SampleCard', className];
    if (checked) {
        classes.push('SampleCard--checked')
    }

    const cartMode = String(className).includes('cart');


    return (
        <div className={`${className} ${classes.join(' ')}`}>
            <div className="SampleCard__body">
                <div className="SampleCard__photo">
                    <Img src={imageUrl} alt="" />

                    <Loader visible={pendingUpdate} zIndex={2} />
                    {/* <img src={imageUrl} alt="" /> */}

                    <div className="SampleCard__photo-name">{name}</div>

                    {onExpandClick ? <button ref={expandRef} type='button' className="SampleCard__expand" onClick={onExpandClick}><ExpandIcon /></button> : null}


                    {cartMode ? (
                        <button className="SampleCard__button"
                            type="button"
                            style={{ zIndex: 5 }}
                            onClick={async () => {
                                if (typeof onClick === 'function') {
                                    setPendingUpdate(true);
                                    await delay(111);
                                    await onClick();
                                    setPendingUpdate(false);

                                }
                            }}
                        >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.8 11.8291L8 8.62911L11.2 11.8291L11.8291 11.2L8.62911 8L11.8291 4.8L11.2 4.17089L8 7.37089L4.8 4.17089L4.17089 4.8L7.37089 8L4.17089 11.2L4.8 11.8291ZM8.00289 16C6.89667 16 5.85659 15.7901 4.88267 15.3702C3.90889 14.9504 3.06178 14.3806 2.34133 13.6609C1.62089 12.9412 1.05059 12.0948 0.630444 11.1218C0.210148 10.1489 0 9.10926 0 8.00289C0 6.89667 0.209926 5.85659 0.629778 4.88267C1.04963 3.90889 1.61941 3.06178 2.33911 2.34133C3.05881 1.62089 3.90518 1.05059 4.87822 0.630444C5.85111 0.210148 6.89074 0 7.99711 0C9.10333 0 10.1434 0.209927 11.1173 0.629778C12.0911 1.04963 12.9382 1.61941 13.6587 2.33911C14.3791 3.05882 14.9494 3.90519 15.3696 4.87822C15.7899 5.85111 16 6.89074 16 7.99711C16 9.10333 15.7901 10.1434 15.3702 11.1173C14.9504 12.0911 14.3806 12.9382 13.6609 13.6587C12.9412 14.3791 12.0948 14.9494 11.1218 15.3696C10.1489 15.7899 9.10926 16 8.00289 16Z" fill="#1F1F1F" />
                            </svg>

                        </button>
                    ) : null}
                </div>
                <div className="SampleCard__buttons">
                    {/* add to cart btn */}

                    {
                        !cartMode ? (
                            <>
                                {inCart ? (
                                    <>



                                        <button className="SampleCard__button remove d-flex a-center" type="button"
                                            onClick={async () => {
                                                if (typeof onClick === 'function') {
                                                    setPendingUpdate(true);
                                                    await onClick();
                                                    setPendingUpdate(false);

                                                }
                                            }}
                                        >
                                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5.24074 13.8742C4.9424 13.8742 4.68829 13.7693 4.4784 13.5595C4.26863 13.3496 4.16374 13.0955 4.16374 12.7972V4.54083H3.49707V3.87416H6.16374V3.36133H10.1637V3.87416H12.8304V4.54083H12.1637V12.7972C12.1637 13.1041 12.061 13.3603 11.8554 13.5658C11.6498 13.7714 11.3936 13.8742 11.0867 13.8742H5.24074ZM11.4971 4.54083H4.8304V12.7972C4.8304 12.9168 4.86885 13.0152 4.94574 13.0922C5.02274 13.1691 5.12107 13.2075 5.24074 13.2075H11.0867C11.1894 13.2075 11.2835 13.1648 11.3689 13.0793C11.4543 12.9939 11.4971 12.8998 11.4971 12.7972V4.54083ZM6.70224 11.8742H7.3689V5.87416H6.70224V11.8742ZM8.95857 11.8742H9.62524V5.87416H8.95857V11.8742Z" fill="#1F1F1F" />
                                            </svg> {_t('remove')}
                                        </button>
                                    </>
                                ) :
                                    (
                                        <div className="SampleCard__text">
                                            <div className="SampleCard__title">{name}</div>

                                        </div>
                                    )}
                                <div className="m-auto"></div>

                                <button disabled={pendingUpdate} className="SampleCard__button" type="button"
                                    onClick={async () => {
                                        if (typeof onClick === 'function') {
                                            setPendingUpdate(true);
                                            await onClick();
                                            setPendingUpdate(false);

                                        }
                                    }}>


                                    {
                                        inCart ? (
                                            <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.564063" y="0.941016" width="27.2" height="27.2" rx="13.6" fill="black" />
                                                <rect x="0.564063" y="0.941016" width="27.2" height="27.2" rx="13.6" stroke="black" strokeWidth="0.8" />
                                                <path d="M12.3268 19.0412L8.05176 14.7662L9.12051 13.6975L12.3268 16.9037L19.208 10.0225L20.2768 11.0912L12.3268 19.0412Z" fill="white" />
                                            </svg>

                                        ) : (
                                            <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1.27427" y="1.14902" width="27.2" height="27.2" rx="13.6" stroke="black" strokeWidth="0.8" />
                                                <path d="M13.9054 19.1049C13.8034 19.0052 13.6802 18.9242 13.5357 18.8619C13.3912 18.7996 13.2382 18.7684 13.0768 18.7684C13.0683 18.7684 13.064 18.7684 13.064 18.7684C12.894 18.7684 12.7347 18.7996 12.5859 18.8619C12.4372 18.9242 12.3076 19.0094 12.1971 19.1174C12.0951 19.2337 12.0122 19.3625 11.9485 19.5037C11.8847 19.645 11.8529 19.7987 11.8529 19.9649C11.8614 20.2889 11.9825 20.5652 12.2162 20.7937C12.4499 21.0222 12.7325 21.1365 13.064 21.1365C13.3955 21.1282 13.6781 21.0098 13.9118 20.7813C14.1455 20.5528 14.2624 20.2765 14.2624 19.9524C14.2624 19.9524 14.2624 19.9504 14.2624 19.9462C14.2624 19.942 14.2624 19.94 14.2624 19.94C14.2624 19.7821 14.2305 19.6305 14.1668 19.4851C14.1031 19.3396 14.0159 19.2129 13.9054 19.1049ZM13.064 20.451C12.979 20.451 12.9046 20.4323 12.8409 20.3949C12.7772 20.3575 12.7198 20.3139 12.6688 20.264C12.6263 20.2142 12.5923 20.1602 12.5668 20.102C12.5413 20.0438 12.5285 19.9774 12.5285 19.9026C12.5285 19.9026 12.5285 19.8984 12.5285 19.8901C12.5285 19.8236 12.5434 19.7592 12.5732 19.6969C12.6029 19.6346 12.6433 19.5827 12.6943 19.5411C12.7368 19.5079 12.7857 19.4809 12.8409 19.4601C12.8961 19.4394 12.9535 19.429 13.013 19.429C13.0215 19.429 13.03 19.429 13.0385 19.429C13.047 19.429 13.0555 19.429 13.064 19.429C13.2085 19.429 13.3317 19.4788 13.4337 19.5785C13.5357 19.6782 13.5867 19.7987 13.5867 19.94C13.5867 20.0812 13.5357 20.2017 13.4337 20.3014C13.3317 20.4011 13.2085 20.451 13.064 20.451ZM19.413 18.7684C19.073 18.7684 18.7862 18.8847 18.5525 19.1174C18.3187 19.35 18.2019 19.6325 18.2019 19.9649C18.2019 20.2889 18.3187 20.5673 18.5525 20.7999C18.7862 21.0326 19.073 21.1489 19.413 21.1489H19.4895C19.8125 21.1406 20.0866 21.0243 20.3118 20.7999C20.537 20.5756 20.6539 20.3056 20.6624 19.9898V19.9524C20.6539 19.6284 20.5328 19.35 20.2991 19.1174C20.0653 18.8847 19.7785 18.7684 19.4385 18.7684C19.4385 18.7684 19.4343 18.7684 19.4258 18.7684C19.4173 18.7684 19.413 18.7684 19.413 18.7684ZM18.8776 19.9649C18.8776 19.8236 18.9285 19.7032 19.0305 19.6035C19.1325 19.5037 19.2558 19.4539 19.4003 19.4539C19.5363 19.4539 19.6531 19.4996 19.7509 19.591C19.8486 19.6824 19.9017 19.7904 19.9102 19.915V19.9649C19.9102 20.1061 19.8592 20.2266 19.7572 20.3263C19.6552 20.426 19.532 20.4759 19.3875 20.4759C19.243 20.4759 19.1219 20.4281 19.0242 20.3326C18.9264 20.237 18.8776 20.1228 18.8776 19.9898V19.9649ZM18.4186 10.3555H9.83851L9.2648 8.62312C9.23931 8.54834 9.19256 8.48395 9.12456 8.42994C9.05657 8.37593 8.97583 8.34893 8.88233 8.34893C8.86533 8.34893 8.84409 8.351 8.81859 8.35516C8.79309 8.35931 8.77184 8.36554 8.75484 8.37385C8.67835 8.39878 8.61248 8.44448 8.55723 8.51095C8.50199 8.57742 8.47437 8.6522 8.47437 8.73529C8.47437 8.76022 8.47649 8.78307 8.48074 8.80384C8.48499 8.82462 8.49136 8.84747 8.49986 8.87239V8.85993L9.74927 12.3746L9.86401 12.7111L11.5341 17.5221H21.2744V13.1349C21.2744 12.7527 21.1979 12.3912 21.0449 12.0506C20.9004 11.7099 20.6985 11.4149 20.4393 11.1657C20.1801 10.9164 19.8762 10.717 19.5278 10.5674C19.1878 10.4262 18.8181 10.3555 18.4186 10.3555ZM20.5094 16.7742H12.0441L10.9222 13.4714L10.1062 11.0909H18.4186C18.9965 11.0909 19.4895 11.2903 19.8975 11.6891C20.3054 12.088 20.5094 12.5699 20.5094 13.1349V16.7742ZM12.0696 16.7742H12.0441L10.9222 13.4714L12.0696 16.7742Z" fill="#212121" />
                                            </svg>
                                        )
                                    }
                                </button>
                            </>

                        ) : (
                            <div className="SampleCard__text">
                                <div className="SampleCard__title">{name}</div>

                            </div>
                        )
                    }


                </div>
            </div>
        </div>
    )
})

SampleCard.displayName = 'SampleCard'
export default SampleCard